export class IndexedDBStorage {
  static DB_NAME = 'cognito-storage';
  static STORE_NAME = 'keyval';
  static DB_VERSION = 1;

  cache = new Map();

  constructor() {}

  setItem(key, value) {
    this.cache.set(key, value);
    this.withStore('readwrite', (store) => store.put(value, key));
  }

  getItem(key) {
    return this.cache.get(key) || null;
  }

  removeItem(key) {
    this.cache.delete(key);
    this.withStore('readwrite', (store) => store.delete(key));
  }

  clear() {
    this.cache.clear();
    this.withStore('readwrite', (store) => store.clear());
  }

  static async create() {
    const storage = new IndexedDBStorage();
    await storage.init();
    return storage;
  }

  async db() {
    return new Promise((resolve, reject) => {
      const openRequest = indexedDB.open(
        IndexedDBStorage.DB_NAME,
        IndexedDBStorage.DB_VERSION,
      );

      openRequest.onupgradeneeded = function () {
        const db = this.result;
        if (!db.objectStoreNames.contains(IndexedDBStorage.STORE_NAME)) {
          db.createObjectStore(IndexedDBStorage.STORE_NAME);
        }
      };

      openRequest.onsuccess = function () {
        resolve(this.result);
      };

      openRequest.onerror = function () {
        reject(this.error);
      };
    });
  }

  async init() {
    const cache = this.cache;

    const db = await this.db();
    const tx = db.transaction(IndexedDBStorage.STORE_NAME, 'readonly');
    const store = tx.objectStore(IndexedDBStorage.STORE_NAME);

    const keysRequest = store.getAllKeys();
    const keys = await new Promise((resolve) => {
      keysRequest.onsuccess = function () {
        resolve(this.result);
      };
    });

    const valuesPromise = keys.map(async (key) => {
      const request = store.get(key);
      return new Promise((resolve) => {
        request.onsuccess = function () {
          resolve({ key, value: this.result });
        };
      });
    });

    const entries = await Promise.all(valuesPromise);
    entries.forEach(({ key, value }) => {
      cache.set(key.toString(), value);
    });
  }

  async withStore(mode, fn) {
    const db = await this.db();
    const tx = db.transaction(IndexedDBStorage.STORE_NAME, mode);
    fn(tx.objectStore(IndexedDBStorage.STORE_NAME));
  }
}
